module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [(_vm.displayError) ? _c('p', {
    staticClass: "error-box"
  }, [_c('i', {
    staticClass: "fa fa-exclamation-triangle",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(_vm._s(_vm.displayError))]) : _vm._e(), _vm._v(" "), (_vm.isLoading) ? _c('div', {
    staticClass: "loading-spinner"
  }, [_c('i', {
    staticClass: "fa fa-spin fa-spinner",
    attrs: {
      "aria-hidden": "true"
    }
  })]) : _vm._e(), _vm._v(" "), _vm._l((_vm.netdevices), function(netdev, index) {
    return _c('div', {
      key: index
    }, [_c('netdevice', {
      attrs: {
        "devmeta": netdev,
        "recurrentServicesInternet": _vm.recurrentServicesInternet
      },
      on: {
        "reload-nodes": function($event) {
          _vm.loadNodes()
        },
        "remove-device-from-view": function($event) {
          _vm.netdevices.splice(index, 1)
        }
      }
    })], 1)
  }), _vm._v(" "), (!_vm.isLoading && _vm.netdevices.length == 0) ? _c('section', [_c('div', {
    staticClass: "alert alert-info",
    attrs: {
      "role": "alert"
    }
  }, [_vm._v("\n      žádná registrovaná koncová zařízení\n    ")])]) : _vm._e(), _vm._v(" "), (_vm.$store.state.customerInfo && _vm.netdevices && _vm.haveAtLeast1InternetService && _vm.netdevices.length < _vm.$store.state.customerInfo['maxnodes1']) ? _c('section', [(!_vm.$store.state.newMacDetected) ? _c('div', [_c('button', {
    staticClass: "btn btn-outline-primary add",
    on: {
      "click": function($event) {
        _vm.addNetDevice()
      }
    }
  }, [_vm._m(0), _vm._v(" "), _c('span', {
    staticClass: "add-label"
  }, [_vm._v("Připojit další koncové zařízení")])])]) : _c('div', [_c('button', {
    staticClass: "btn btn-outline-primary add",
    on: {
      "click": function($event) {
        _vm.addNetDevice(_vm.$store.state.newMacDetected)
      }
    }
  }, [_vm._m(1), _vm._v(" "), _c('span', {
    staticClass: "add-label"
  }, [_vm._v("Připojit další koncové zařízení s MAC adresou " + _vm._s(_vm.$store.state.newMacDetected))])])])]) : _vm._e(), _vm._v(" "), _c('p', [_vm._v(" ")])], 2)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [_c('i', {
    staticClass: "fa fa-plus-square-o"
  }), _vm._v("   ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [_c('i', {
    staticClass: "fa fa-plus-square-o"
  }), _vm._v("   ")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2cce5160","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/MyNetDevices.vue
// module id = 301
// module chunks = 1 2